module.exports = __webpack_public_path__ + "img/3.0f9441a7.png";